import { fromJS } from 'immutable';

import {
  GET_BUILDER_LOGO,
  GET_BUILDER_BANNER,
  GET_BUILDER_PROJECT_GALLERY,
  RESET_BUILDER_PROJECT_GALLERY,
  REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY,
} from '../actions/actionTypes';

const initialState = fromJS({
  builderProfilePhoto: null,
  builderBannerPhoto: null,
  builderProjectGallery: [],
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUILDER_LOGO:
      return state.set('builderProfilePhoto', action.payload);
    case GET_BUILDER_BANNER:
      return state.set('builderBannerPhoto', action.payload);
    case GET_BUILDER_PROJECT_GALLERY:
      return state.update('builderProjectGallery', image =>
        image.push(fromJS(action.payload)),
      );
    case REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY:
      return state.update('builderProjectGallery', image =>
        image.splice(action.payload, 1),
      );
    case RESET_BUILDER_PROJECT_GALLERY:
      return state.update('builderProjectGallery', image => image.clear());
    default:
      return state;
  }
};

export default reducer;
